import Beneficiary from '@/models/onboarding/beneficiary';
import { compact } from '@/utilities/helpers';

export default class BeneficiarySerializer {
  static serialize(model) {
    const beneficiary = {};

    beneficiary.name = {};
    beneficiary.name.givenName = model.givenName;
    beneficiary.name.familyName = model.familyName;

    beneficiary.relationship = model.relationship;
    beneficiary.dateOfBirth = model.dateOfBirth;
    beneficiary.socialSecurityNumber = model.socialSecurityNumber;
    beneficiary.beneficiaryType = model.beneficiaryType;
    beneficiary.sharePercent = parseInt(model.sharePercent);

    beneficiary.address = {};
    beneficiary.address = {
      streetAddress: compact([model.address.streetAddress, model.address.streetAddress2]),
      postalCode: model.address.postalCode,
      city: model.address.city,
      state: model.address.state,
      // we only allow USA address presently
      country: 'USA',
    };

    return beneficiary;
  }

  static deserialize({ data }) {
    // console.log('Beneficiary#deserialize', data);
    if (Array.isArray(data)) {
      return BeneficiarySerializer.deserializeArray(data);
    }
    return BeneficiarySerializer.deserializeObject(data);
  }

  static deserializeArray(jsonArray) {
    // console.log('Beneficiary#deserializeArray', arguments);
    return jsonArray.map((el) => BeneficiarySerializer.deserializeObject(el));
  }

  static deserializeObject(json) {
    // console.log('Beneficiary#deserializeObject', arguments);
    const beneficiary = {};

    beneficiary.givenName = json.name?.givenName;
    beneficiary.familyName = json.name?.familyName;
    beneficiary.relationship = json.relationship;
    beneficiary.dateOfBirth = json.dateOfBirth;
    beneficiary.socialSecurityNumber = json.socialSecurityNumber;
    beneficiary.beneficiaryType = json.beneficiaryType;
    beneficiary.sharePercent = json.sharePercent;
    beneficiary.address = {
      streetAddress: json.address.streetAddress[0],
      streetAddress2: json.address.streetAddress[1] || undefined,
      postalCode: json.address.postalCode,
      city: json.address.city,
      state: json.address.state,
      country: json.address.country,
    };

    return new Beneficiary(beneficiary);
  }
}
